import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { constant } from '../../app.constants';
import { ParentService } from '../A2-utils/ParentClass/ParentService';
import { AgGridActionsEnum } from 'app/core/enums/ag-grid-actions.enums';
import { TabsUnverifiedTripsEnum } from 'app/core/enums/tabs-unverified-trips.enum';

@Injectable()
export class DataProcessingService extends ParentService {
  public closeModal = new BehaviorSubject<boolean>(true);
  closeModal$ = this.closeModal.asObservable();
  public tripIdList = new BehaviorSubject<number[]>([]);
  tripIdList$ = this.tripIdList.asObservable();

  private reloadGrid = new BehaviorSubject<boolean>(false);
  reloadGrid$ = this.reloadGrid.asObservable();
  tabsCurrent = constant.UNVERIFIED_TRIPS.TABS_UNVERIFIED_TRIPS;
  actionGrid = new BehaviorSubject<{
    isSubmit: boolean,
    action: AgGridActionsEnum,
    dataList?: any[],
    selectedTab?: TabsUnverifiedTripsEnum,
    showSetPlanTypeAndRegionButton?: boolean
  }>(null);
  actionGrid$ = this.actionGrid.asObservable();

  private changePlanType = new BehaviorSubject<boolean>(null);
  changePlanType$ = this.changePlanType.asObservable();

  constructor(private _http: Http, private route: Router) {
    super();
    // this.verifyToken(this._http, route);
  }

  public getReloadGrid(params) {
    this.reloadGrid.next(params);
  }
  /**
   * @name  importFilePayor
   * @description
   * @param file
   * @param id
   * @returns {Observable<R>}
   */
  private importFilePayor(file, id) {
    const bodyString = JSON.stringify(file);
    return this._http
      .post(constant.URL_IMPORT_PAYOR + id, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getFormList
   * @description :TODO: Filtrar las formas activas.
   */
  getFormList(): Observable<any> {
    return this._http.get(constant.URL_EXPORT_FORM_LIST, this.headerPost()).pipe(
      map((response: any) => response.json()),
      catchError((error: any) => Observable.throw(error.json()))
    );
  }

  /**
   * @name getFormList
   * @description :TODO: Filtrar billingschedule con las formaid selecionada.
   */
  getListBillingScheduleByFormId(formId: string | number): Observable<Response> {
    const URL = `${constant.URL_BILLING_SCHEDULE_LIST}?formid=${formId}`;
    return this._http.get(URL, this.headerPost()).pipe(
      map((response: any) => response.json()),
      catchError((error: any) => Observable.throw(error.json()))
    );
  }

  /**
   * @name getFormList
   * @description :TODO: Filtrar payor por formid and billingscheduleid.
   */
  getPayorByFomrIdAndBillingScheduleId(formId: string | number,
                                       billingScheduleId:  string | number): Observable<Response> {
    const URL = `${constant.URL_PAYOR_LIST}?showInactive=true&formid=${formId}` +
                `&billingScheduleId=${billingScheduleId}`;
    return this._http.get(URL, this.headerPost()).pipe(
      map((response: any) => response.json()),
      catchError((error: any) => Observable.throw(error.json()))
    );
  }

  /**
   * @name dataToExportTrips
   * @description
   * @param begin
   * @param end
   */
  dataToExportTrips(initialdate, finaldate, payoridslist, verified?,
                    claimStatusId?, formid?: any, billingscheduleid?: any,
                    morethan50milesonly: boolean = false,
                    showduplicates: boolean = false,
                    currentTabSelected?: number,
                    rowsPerPage?: number, page?: number,
                    isTenence: boolean = false,
                    providertype?
                  ) {
    const body: any = {
      payoridslist,
      initialdate,
      finaldate,
      billingstatusid: verified,
      claimStatusId: claimStatusId,
      formid: formid === undefined ? null : formid,
      billingscheduleid: billingscheduleid === undefined ? null : billingscheduleid,
      providertypes: providertype
    };

    if ((currentTabSelected === this.tabsCurrent.UnverifiedTrips || currentTabSelected === this.tabsCurrent.ExportZoll)) {
      body.morethan50milesonly = currentTabSelected === this.tabsCurrent.UnverifiedTrips ? morethan50milesonly : null;
      body.showduplicates = currentTabSelected === this.tabsCurrent.UnverifiedTrips || currentTabSelected === this.tabsCurrent.ExportZoll  ? showduplicates : null;
      body.rows = rowsPerPage;
      body.page = page;
    }

    if (currentTabSelected === this.tabsCurrent.ExportZoll ) {
      delete body.morethan50milesonly;
    }

    if (!morethan50milesonly) {
      delete body.morethan50milesonly;
    }

    if (!claimStatusId) {
      delete body.claimStatusId;
    }


    return this._http
      .post(constant.URL_EXPORT_TRIPS, JSON.stringify(body), this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name dataToExportTrips
   * @description
   * @param begin
   * @param end
   */
  dataToExportTripsECM(initialdate, finaldate, payorid, tripsqty, showsent, isResubmission = false, showDuplicates = false) {
    const body = {
      payorid,
      initialdate,
      finaldate,
      tripsqty,
      showsent,
      isResubmission,
      showDuplicates
    };
    return this._http
      .post(`${constant.URL_FORMEXPORT_TRIPS}?isResubmission=${isResubmission}`, JSON.stringify(body), this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  verifyTrips(tripids) {
    const body = JSON.stringify(tripids);

    return this._http
      .put(constant.URL_VERIFY_TRIPS, body, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name exportTripsToZoll
   * @description
   * @param data
   */
  exportTripsToZoll(data) {

    const body = (data);
    const headers = new Headers({
      'Content-Type': 'application/json',
      'MyApp-Application': 'AppName',
      'Accept': 'application/zip',
      'Version': this.localVersion
    });
    const options = new RequestOptions({
      headers: headers,
      responseType: ResponseContentType.Blob
    });
    return this._http
      .put(constant.URL_EXPORT_TO_ZOLLDATA, body, options)
      .map((res: Response) => res)
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @description
   * @param data
   */
  recalcualteData(data) {
    return this._http.put(constant.URL_RECALC_EXPORT, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * @name getTripsSafety
   * @description Cargar trups safety
   * @param brokerId
   * @param payorId
   */
  getTripsIntegration(brokerId, payorId) {
    return this._http
      .get(`${constant.BASIC}integration/${brokerId}/${payorId}/Trips`, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  acceptTripsSafety(brokerId, payorId, trips) {
    const bodyString = JSON.stringify(trips);
    return this._http
      .post(`${constant.BASIC}integration/${brokerId}/${payorId}/AcceptTrips`, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  rerouteTripsSafety(brokerId, payorId, trips) {
    const bodyString = JSON.stringify(trips);
    return this._http
      .put(`${constant.BASIC}integration/${brokerId}/${payorId}/ReRoute`, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * this generate TACMSERROS Report
   */
  generateTacmsErrorsReport(date) {
    return this._http
      .get(`${constant.BASIC}Report/CreateErrorReport/${date}`, this.getFileHeaders())
      .catch((error: any) => Observable.throw(error.json()));
  }

  /**
   * this generate duplicate modifiers Report
   */
  generateDuplicateModifierReport(date) {
    return this._http
      .get(`${constant.BASIC}Report/DuplicateModifiers/${date}`, this.getFileHeaders())
      .catch((error: any) => Observable.throw(error.json()));
  }

  generateFile837(
    {
      formId,
      trips,
      isResubmission,
      force = false
    }: { formId: number, trips: any[], isResubmission: boolean, force?: boolean }
  ): Observable<any> {
    const bodyString = JSON.stringify(trips);
    let urlRequest = `${constant.BASIC}FormExport/ExportTripsByForm?formId=${formId}&isResubmission=${isResubmission}`;

    if (force) {
      urlRequest += `&force=${force}`;
    }

    return this._http.post(urlRequest, bodyString, this.getFileHeaders())
      .map((res: any) => res)
      .catch((error: any) => Observable.throw(error));
  }

  generateFile837ByInvoiceBatch(
    invoiceBatchId: number,
    form: number,
    isReplacement: any
  ): Observable<any> {
    return this._http
      .get(
        `${constant.URL_FORMEXPORT_DOWNLOADFILE_BYINVOICEBATCH}/${invoiceBatchId}/${form}/${isReplacement}`,
        this.getFileHeaders()
      )
      .map((res: any) => res)
      .catch((error: any) => Observable.throw(error));
  }

  getBillingStatuses() {
    return this._http
      .get(`${constant.BASIC}Export/BillingStatus`, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getClaimStatus() {
    return this._http.get(constant.CLAIM_STATUS, this.getHeader());
  }

  posSendToTrip2(data: any) {
    const bodyString = JSON.stringify(data);
    return this._http.post(constant.SEND_TRIP2_CLM_TO_ORIGIN, bodyString, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  senExportZoll(data) {
    return this._http.put(constant.URL_EXPORT_TO_ZOLLDATA, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  providerAmount(data) {
    return this._http.put(constant.URL_RECALC_PROVIDER_AMOUNT, data, this.headerPost())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getAllForms() {
    return this._http
      .get(`${constant.BASIC}Form/list`, this.getHeader())
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  loadTripsToExportByTripId (data) {
    return this._http.post(`${constant.URL_LOAD_TRIPS_BY_ID}`, data, this.headerPost())
    .map((res: Response) => res.json())
    .catch((error) => Observable.throw(error.json()));
  }

  getErrorsBytripId(tripId: number) {
    return this._http.get(`${constant.URL_ERRORS_BY_TRIPID}/${tripId}`, this.getHeader())
    .map((res: Response) => res.json())
    .catch((error) => Observable.throw(error.json()));
  }

  getPayorsType() {
    return this._http.get(`${constant.URL_PAYOR_TYPE}`, this.getHeader())
    .map((res: Response) => res.json())
    .catch((error) => Observable.throw(error.json()));
  }

  getProviderType() {
    const url = `${constant.URL_PROVIDER_TYPE}?showInactive=true`;
    return this._http.get(url, this.getHeader())
    .map(response => response.json())
    .catch((error) => Observable.throw(error.json()));
  }

  setNonDuplicate(tripIds: number[]) {
    return this._http
      .put(
        constant.URL_FORMEXPORT_SETNONDUPLICATE_TRIPS,
        tripIds,
        this.headerPost()
      )
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  setModifier(data: any) {
    return this._http
      .put(
        constant.URL_FORMEXPORT_SETMODIFIER_TRIPS,
        data,
        this.headerPost()
      )
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  setChangePlanType(changePlanType: boolean): void {
    this.changePlanType.next(changePlanType);
  }

  changePlanTypeService(reservationIds: number[]): Observable<any> {
    return this._http
      .put(
        constant.URL_FORMEXPORT_CHANGE_PLANTYPE,
        reservationIds,
        this.headerPost()
      )
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/data-processing/data-processing.service.ts